type CreateAudioRecorderResult = {
  stream: MediaStream;
  recorder: MediaRecorder;
  mimeType: string;
};

/** `exact`, so a vanished device fails instead of silently falling back to another one. */
export async function createAudioRecorder(deviceId?: string): Promise<CreateAudioRecorderResult> {
  if (
    typeof navigator === 'undefined' ||
    !navigator.mediaDevices ||
    !navigator.mediaDevices.getUserMedia
  ) {
    throw new Error('BrowserError');
  }

  if (typeof MediaRecorder === 'undefined') {
    throw new Error('BrowserError');
  }

  const requiredMimeType = 'audio/webm;codecs=opus';

  if (!MediaRecorder.isTypeSupported(requiredMimeType)) {
    throw new Error('BrowserError');
  }

  const stream = await navigator.mediaDevices.getUserMedia({
    audio: deviceId ? { deviceId: { exact: deviceId } } : true,
  });
  const recorder = new MediaRecorder(stream, {
    mimeType: requiredMimeType,
  });

  return {
    stream,
    recorder,
    mimeType: requiredMimeType,
  };
}
